import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const deleteResolution = async ({ productId, resolutionId }) => {
  try {
    const user = getUserDetails();

    const response = await axios.post(`
        ${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deleteResolution&productId=${productId}&resolutionId=${resolutionId}&companyId=${user.companyid}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting resolution:", error);
    throw error;
  }
};

const useDeleteResolution = (options = {}) => {
  return useMutation({
    mutationFn: deleteResolution,
    ...options,
  });
};

export default useDeleteResolution;
